// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"a83ec8f5","457":"8e4a4192","538":"2b10fc76","551":"0e560a09","828":"eb7fc830","856":"2de389be"}[chunkId] + ".chunk.js";
};